import React from 'react';
export const UnderConstructionCone = () => (
  <svg width="128px" height="83px" viewBox="0 0 128 83" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-810.000000, -1500.000000)">
        <g transform="translate(811.000000, 1501.000000)">
          <path
            d="M119.1197,81.1596 L125.8647,81.1596"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.2774,81.1596 L0.2414,81.1596"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.7256,5.7856 L67.7556,5.7856"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M65.4932,3.0629 L57.4632,3.0629 C57.4632,3.0629 55.7992,2.8969 55.7992,1.7629 C55.7992,0.6289 56.5252,0.4639 56.5252,0.4639"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M17.8853,23.8539 L25.9153,23.8539"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M23.6529,21.1303 L15.6229,21.1303 C15.6229,21.1303 13.9589,20.9653 13.9589,19.8313 C13.9589,18.6973 14.6839,18.5323 14.6839,18.5323"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <polygon
            fill="#FFFFFF"
            points="45.5782 81.1928 42.4722 81.1928 33.8772 34.2328 37.3232 34.2328"
          />
          <polygon
            stroke="#D6D6D6"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.5782 81.1928 42.4722 81.1928 33.8772 34.2328 37.3232 34.2328"
          />
          <g transform="translate(31.000000, 53.710000)">
            <polyline
              fill="#FFFFFF"
              points="39.7847 0.8871 41.1047 0.8871 41.1047 13.8681 0.8477 13.8681 0.8477 0.8871 2.1077 0.8871"
            />
            <polyline
              stroke="#A0A8AA"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="39.7847 0.8871 41.1047 0.8871 41.1047 13.8681 0.8477 13.8681 0.8477 0.8871 2.1077 0.8871"
            />
          </g>
          <g transform="translate(48.000000, 53.710000)">
            <path d="M0.5635,0.8871 L22.7845,0.8871" fill="#FFFFFF" />
            <path
              d="M0.5635,0.8871 L22.7845,0.8871"
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(33.000000, 53.710000)">
            <path d="M0.108,0.8871 L11.374,0.8871" />
            <path
              d="M0.108,0.8871 L11.374,0.8871"
              stroke="#A0A8AA"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polygon
            fill="#DDE5E8"
            points="70.79 65.109 78.494 65.109 78.494 54.597 70.79 54.597"
          />
          <polygon
            fill="#FFFFFF"
            points="33.867 49.939 75.728 49.939 75.728 36.958 33.867 36.958"
          />
          <polygon
            stroke="#A0A8AA"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="33.867 49.939 75.728 49.939 75.728 36.958 33.867 36.958"
          />
          <polygon
            fill="#8230DF"
            points="67.899 36.5043 76.057 50.4413 70.345 50.4413 62.366 36.5043"
          />
          <polygon
            fill="#8230DF"
            points="53.6197 36.5043 61.7777 50.4413 56.0657 50.4413 48.0867 36.5043"
          />
          <polygon
            fill="#8230DF"
            points="39.3409 36.5043 47.4979 50.4413 41.7869 50.4413 33.8079 36.5043"
          />
          <polygon
            fill="#FFFFFF"
            points="84.525 81.1928 81.419 81.1928 72.824 34.2328 76.27 34.2328"
          />
          <polygon
            stroke="#D6D6D6"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="84.525 81.1928 81.419 81.1928 72.824 34.2328 76.27 34.2328"
          />
          <path
            d="M81.3726,51.5307 C81.3726,51.5307 82.2036,61.0677 73.4816,57.0197"
            stroke="#391572"
            strokeLinecap="round"
          />
          <g transform="translate(27.000000, 33.710000)">
            <polyline
              fill="#FFFFFF"
              points="6.2584 5.3646 6.8704 0.5226 10.3164 0.5226 4.0424 47.4826 0.9364 47.4826 5.5404 11.0486"
            />
            <polyline
              stroke="#A0A8AA"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="6.2584 5.3646 6.8704 0.5226 10.3164 0.5226 4.0424 47.4826 0.9364 47.4826 5.5404 11.0486"
            />
          </g>
          <polygon
            fill="#FFFFFF"
            points="72.105 81.1928 68.999 81.1928 72.611 34.2328 76.056 34.2328"
          />
          <polygon
            stroke="#A0A8AA"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="72.105 81.1928 68.999 81.1928 72.611 34.2328 76.056 34.2328"
          />
          <polygon
            fill="#A0A8AA"
            points="72.5279 38.5404 72.5279 41.3454 74.9029 42.0244 75.0949 40.4014"
          />
          <polygon
            fill="#F3F4F6"
            points="35.0806 55.1586 33.5256 66.9766 37.3156 66.9766 44.3756 55.1586"
          />
          <polygon
            fill="#391572"
            points="84.7056 49.6381 84.0226 48.7161 78.3876 44.1061 78.0396 46.0621 80.9116 48.2361 80.9056 50.4671 83.4616 50.9711"
          />
          <g transform="translate(65.000000, 27.710000)">
            <path
              d="M7.0215,2.6693 L6.9745,2.7033 L4.9685,5.2793 L2.3385,4.1613 C2.3385,4.1613 1.0945,3.5853 0.4455,4.3533 C-0.2025,5.1203 0.6615,6.2693 0.6615,6.2693 L7.9535,10.9223 L19.0245,19.8213 L20.7995,21.8533 L22.6985,20.9083 L22.2935,19.2673 C22.4865,18.7603 22.8605,18.2583 23.2555,17.7303 C23.6275,17.2323 24.0115,16.7163 24.2995,16.1303 C26.8895,10.8653 24.4535,4.3473 18.8715,1.6003 C16.5095,0.4393 13.6865,0.2073 11.0565,0.8463"
              fill="#FFD400"
            />
            <path
              d="M7.0215,2.6693 L6.9745,2.7033 L4.9685,5.2793 L2.3385,4.1613 C2.3385,4.1613 1.0945,3.5853 0.4455,4.3533 C-0.2025,5.1203 0.6615,6.2693 0.6615,6.2693 L7.9535,10.9223 L19.0245,19.8213 L20.7995,21.8533 L22.6985,20.9083 L22.2935,19.2673 C22.4865,18.7603 22.8605,18.2583 23.2555,17.7303 C23.6275,17.2323 24.0115,16.7163 24.2995,16.1303 C26.8895,10.8653 24.4535,4.3473 18.8715,1.6003 C16.5095,0.4393 13.6865,0.2073 11.0565,0.8463"
              stroke="#F28400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M73.0147,32.4731 C73.0147,32.4731 75.7137,29.6921 78.0397,29.6921 C80.3667,29.6921 82.3767,31.3101 82.3767,31.3101 L73.0147,32.4731 Z"
            fill="#FFFFFF"
          />
          <path
            d="M88.4356,40.2455 L81.3726,42.6935 C81.3726,42.6935 85.1716,44.3655 85.8516,46.0115 C87.8916,44.1055 88.4356,40.2455 88.4356,40.2455"
            fill="#EDAA14"
          />
          <polygon
            fill="#FFFFFF"
            points="93.3233 80.9516 101.1703 52.7836 103.6093 52.7936 112.1483 80.9516"
          />
          <polygon
            stroke="#A01603"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="93.3233 80.9516 101.1703 52.7836 103.6093 52.7936 112.1483 80.9516"
          />
          <polygon
            fill="#ED0722"
            points="96.5865 71.3139 108.7065 71.3139 111.5265 80.6189 93.9695 80.6669"
          />
          <polygon
            fill="#ED0722"
            points="98.6109 63.81 106.4459 63.908 107.0439 65.88 98.0819 65.783"
          />
          <path
            d="M89.9156,80.9516 L115.6986,80.9516"
            stroke="#391572"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
